import keyMirror from 'keymirror';

const PI = keyMirror({
  // TODO agregar casos mixtos y no_plus
  BASIC: null,
  PARTIAL_PLUS_SEP: null,
  PARTIAL_PLUS_SXP: null,
  PARTIAL_SDE: null,
  PARTIAL_SXC: null,
  MIX_PLUS: null,
  PLUS: null,
  UNPROTECTED: null,
  MIX_INSURANCE: null,
  AMS: null,
  SEP: null,
  SXP: null,
  SDE: null,
  SXC: null,
});

export default PI;
